import { Helmet } from 'react-helmet-async';

// Helmet without its requestAnimationFrame defer, which never fires in hidden tabs, leaving the static title.
function PageHead(props) {
    return <Helmet defer={false} {...props} />;
}

export default PageHead;
